












































import Vue from 'vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import CustomSelect from '../selects/CustomSelect.vue';
import { ICustomSelectOption } from '../../../common/interfaces/shared.interface';
import config from '../../../../config';
import CookieHelper from '../../../helpers/CookieHelper';

interface IVoucherAssignmentMessageTemplateComponent {
  $refs?: IVoucherAssignmentMessageTemplateRefs;
  copySuccessfulHint: boolean;
  currentTemplateLang: string;
}

interface IVoucherAssignmentMessageTemplateRefs {
  templateTextArea: HTMLTextAreaElement;
}

export default Vue.extend({
  name: `VoucherAssignmentMessageTemplate`,
  components: { CustomButton, CustomSelect },
  data(): IVoucherAssignmentMessageTemplateComponent {
    return {
      copySuccessfulHint: false,
      currentTemplateLang: CookieHelper.getLanguage(),
    };
  },
  computed: {
    langOptions(): ICustomSelectOption<string>[] {
      return config.locize.languageKeys.map(key => ({ optionText: key.toUpperCase(), optionValue: key, selected: key === this.currentTemplateLang }));
    },
    templateText(): string {
      const formattedVoucherCode = `${this.voucherCode.substring(0, 4)}-${this.voucherCode.substring(4, 10)}-${this.voucherCode.substring(10, 14)}`;
      return this.$t(`header:vouchers.emailBody`, { lng: this.currentTemplateLang, voucherCode: formattedVoucherCode });
    },
  },
  props: {
    voucherCode: {
      required: true,
      type: String,
    },
  },
  methods: {
    copyText(): void {
      this.$refs.templateTextArea.select();
      navigator.clipboard.writeText(this.$t(`header:vouchers.emailBody`));
      this.copySuccessfulHint = true;
      setTimeout(() => {
        this.copySuccessfulHint = false;
      }, 5000);
    },
  },
});
